const Minus2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10.5 1H1.5Z" fill="currentColor"></path>
    <path
      d="M10.5 1H1.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export { Minus2 };
